import { render } from "./Home.vue?vue&type=template&id=ae81dbfc"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script